"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
var OauthProvider;
(function (OauthProvider) {
    OauthProvider["Adobe"] = "adobe";
})(OauthProvider = exports.OauthProvider || (exports.OauthProvider = {}));
class OAuthClient extends authenticated_client_1.AuthenticatedClient {
    authorize(service, redirect) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = this.getConfig();
            return `${config.url}/v1/oauth/authorize?service=${service}&redirect=${btoa(redirect)}`;
        });
    }
}
exports.OAuthClient = OAuthClient;
//# sourceMappingURL=oauth.client.js.map